export const ACCESS_TOKEN_KEY = "access_token";
export const SEARCH_PREF_ID = "SEARCH_PREF_ID";
export const IS_REGIST_AGREE = "IS_REGIST_AGREE";
export const SEARCH_PARAMS = "search_params";
export const CONFIRM_PUSH_NOTIFICATION = "confirm_push_notification";
